// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/postcss-loader/dist/cjs.js!../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text_vNwQ9 {
  
}

.dim__BJSS {
  color : var( --light-grey );
}`, "",{"version":3,"sources":["webpack://./src/views/text.css"],"names":[],"mappings":"AAEA;;AAEA;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["@import \"../style/theme.css\";\n\n.text {\n  \n}\n\n.dim {\n  color : var( --light-grey );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `text_vNwQ9`,
	"dim": `dim__BJSS`
};
export default ___CSS_LOADER_EXPORT___;
